<template>
  <el-tag v-if="priorityName" size="medium" :type="cssClass"
  >{{ priorityName }}
  </el-tag>
</template>

<script>
  import constants from "../../../constants";

  export default {
    name: "doc-priority-tag",
    props: ["priorityId", "priorityName"],

    data() {
      return {
        cssClass: null
      }
    },

    watch: {
      priorityId() {
        this.cssClass = this.initCssClass();
      }
    },

    created() {
      this.cssClass = this.initCssClass();
    },

    methods: {
      initCssClass() {
        return constants.HIGH_LEVELS_PIORITY_IDS.indexOf(this.priorityId) !== -1
          ? "danger"
          : "";
      }
    }
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/doc-out/achievement/doc-priority-tag.vue